import React, {Component} from "react";
import {connect, useDispatch, useSelector} from "react-redux";
import BaseTextField from "../../../Base/ui/inputs/TextField";
import updateAssociationName from "../helpers/update_association_name";

const TextField = ({resource = 'affiliateMemberDetail', name, label, col, action, textDecorator, required}) => {
  const value = useSelector((state) => {
    if (state[resource] === null) {
      return '';
    } else {
      const fieldValue = state[resource][name];
      return Array.isArray(fieldValue) ? fieldValue.join(', ') : fieldValue;
    }
  });

  const dispatch = useDispatch();
  const fieldAction = action || useSelector((state) => state.ui.action);

  const dispatchChange = (name, value) => {
    dispatch({type: `UPDATE_${updateAssociationName(resource)}`, payload: {name, value}})
  }

  const handleChange = (e) => {
    textDecorator
      ? dispatchChange(
        name,
        textDecorator(e.target.value)
      )
      : dispatchChange(name, e.target.value);
  }

  return (
    <BaseTextField
      resource={resource}
      name={name}
      label={label}
      col={col}
      value={value}
      required={required}
      action={fieldAction}
      onChange={handleChange}
    />
  );
}

export default TextField;
